import VueCookies from 'vue-cookies'

let domain = '';
let re = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/

if (re.test(window.location.hostname) || window.location.hostname === 'localhost') {
  //域名
  domain = window.location.hostname
} else {
  //域名 不包含www 前面拼接 '.'
  let urlArr = window.location.hostname.split('.');
  urlArr.forEach((item, i) => {
    if (item !== 'www' && i !== 0) {
      domain += `.${item}`;
    }
  })
}


//新增 setCookie 方法
VueCookies.setCookie = function (name, value, expires, path) {
  if (!name || !value) {
    return console.error('name & value is required!')
  }
  VueCookies.set(name, value, expires ? expires : '1d', path ? path : '/', domain)
}

//新增 removeCookie 方法
VueCookies.removeCookie = function (name, path) {
  if (!name) {
    return console.error('name is required!')
  }
  VueCookies.remove(name, path ? path : '/', domain)
}

export default VueCookies



// WEBPACK FOOTER //
// ./src/utils/vueCookie.js